import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { create } from "lodash";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";

const initialListingsState = {
  agentSettingsList: [],
  agentSettingsMeta: {},
  currentPage: 1,
  pageSize: 10,
  selectedRowData: {},
  queueList: [],
  sortOrder: '',
  sortField: '',
  listLoading: false,
  queueMappingHistoryList: [],
  is_auto_answer:{enable:false, delay:""},
};


export const fetchAgentSettingsLists = createAsyncThunk(
  "agentSettingsSlice/fetchAgentSettingsLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getAgentSettingsListing, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "agentsettings_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "agentsettings_lists",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchAgentQueuesLists = createAsyncThunk(
  "agentSettingsSlice/fetchAgentQueuesLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getAgentsQueueInfo, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "agentsettings_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      dispatch(
        actions.setLoadingState({
          resource: "agentsettings_lists",
          loading_state: "loaded",
        })
      );
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchQueueMappingHistory = createAsyncThunk(
  "agentSettingsSlice/fetchQueueMappingHistory",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getQueueMappingHistory, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "agentsettings_dialog",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const manageAgentsDialogTabSlice = createSlice({
  name: "manageAgentsDialogTabSlice",
  initialState: { selectedManageAgentsTab: '0', selectedAgentRowData: {} },
  reducers: {
    onTabChange: (state, action) => {
      const { payload } = action;
      state.selectedManageAgentsTab = payload;
    },
    onEditAgent: (state, action) => {
      const { payload } = action;
      state.selectedAgentRowData = payload;
    },
  },
});

export const agentSettingsSlice = createSlice({
  name: "agentSettingsSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase(fetchAgentSettingsLists.pending, (state) => {
      state.agentSettingsList = [];
    });
    builder.addCase(fetchAgentSettingsLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      const { meta, objects } = data;
      state.agentSettingsList = objects;
      state.agentSettingsMeta = meta;
    });

    builder.addCase(fetchQueueMappingHistory.pending, (state) => {
      state.queueMappingHistoryList = [];
      state.listLoading = true;
    });
    builder.addCase(fetchQueueMappingHistory.fulfilled, (state, { payload }) => {
      const { data } = payload;
      state.listLoading = false;
      state.queueMappingHistoryList = data.data;
    });
    builder.addCase(fetchQueueMappingHistory.rejected, (state, action) => {
      state.listLoading = false;
    });

    builder.addCase(fetchAgentQueuesLists.pending, (state) => {
      state.queueList = [];
    });
    builder.addCase(fetchAgentQueuesLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      // const { details } = data;
      state.queueList = data;
    });
    builder.addCase(fetchAgentQueuesLists.rejected, (state, action) => {});

  },
  
  reducers: {
    onPageAndPageSizeChange: (state, action) => {
      const { payload } = action;
      state.currentPage = payload["currentPage"];
      state.pageSize = payload["pageSize"];
      state.sortOrder = payload["sortOrder"];
      state.sortField = payload["sortField"];
    },
    // onSortingChange: (state, action) => {
    //   const { payload } = action;
    //   state.sortOrder = payload["sortOrder"];
    //   state.sortField = payload["sortField"];
    // },
    rowSelectionData: (state, action) => {
        state.actionsLoading = false;
        state.selectedRowData = action.payload;
        state.error = null;
    },
     onAutoAnswerChange: (state, action) => {
      const { payload } = action;
      state.is_auto_answer = payload;
    },
  },
});


export const { onPageAndPageSizeChange, onSortingChange, rowSelectionData, onAutoAnswerChange} = agentSettingsSlice.actions;
export const { onTabChange, onEditAgent } = manageAgentsDialogTabSlice.actions;

export default agentSettingsSlice.reducer;
